
const routers = [
  { path: '/', component: '../pages/home', showMenu: true },
  { path: '/movieDetail', component: '../pages/movieDetail/index', showMenu: false},
  { path: '/cinema', component: '../pages/cinema/index', showMenu: false  },
  { path: '/cinemaDetail', component: '../pages/cinemaDetail/index', showMenu: false },
  { path: '/movieSeat', component: '../pages/movieSeat/index', showMenu: false },
  { path: '/map', component: '../pages/map/index', showMenu: false },
  // { path: '/orderConfirm', component: '../pages/orderConfirm/index',showMenu: false },
  { path: '/order/confirm', component: '../pages/order/confirm/index', showMenu: false },
  { path: '/orders', component: '../pages/order/list/index', showMenu: false },
  { path: '/order/status', component: '../pages/order/status/index', showMenu: false },
  { path: '/movieListDetail', component: '../pages/movieList/checkLoading', showMenu: false },
  { path: '/movieList', component: '../pages/movieList/index', showMenu: false },
  { path: '/payResult/succ', component: '../pages/payResult/succ', showMenu: false },
  { path: '/applyRefund', component: '../pages/applyRefund/index', showMenu: false },
  { path: '/applyRefundDetail', component: '../pages/applyRefundDetail/index', showMenu: false },
  { path: '/refundExplain', component: '../pages/refundExplain/index', showMenu: false },
  { path: '*', component: '../pages/notFound/index', showMenu: false }
];
module.exports  = routers;
// export default routers



